export const locale = {
  'basic-info': 'Review Your Information',
  credentials: 'Create Credentials',
  identification: 'Verify Your Identity',
};
